import React, { useEffect, useState } from 'react';
import GroupDetail from '../../../components/Protocols/Groups/GroupDetail';
import { getPatientsInGroupAPI } from '../../../api/protocolGroups';
import { useGroups, useGroupPractitioners, useGroupPatients, useGroupPatientsPractitioner } from './useGroups';
import { HandleError } from '../../../components/Notifications/APIErrorHandler';
import { Success } from '../../../components/Notifications/Notifications';
import { useTranslation } from "react-i18next";
import { ModalConfirm } from '../../../components/Modals/ModalConfirm';
import { ModalReassignPatients } from './ModalReassignPatients'
import EditGroup from '../../../components/Protocols/Groups/ModalEditGroup.jsx';
import DeleteAllUsers from '../../../components/Protocols/Groups/DeleteAllUsers.jsx';
import DeleteAllPatients from '../../../components/Protocols/Groups/DeleteAllPatients.jsx'; 
import AddPractitioners from '../../../components/Protocols/Groups/AddPractitioners.jsx';
import AddPatients from '../../../components/Protocols/Groups/AddPatients.js';
import DeletePractitioner from '../../../components/Protocols/Groups/DeletePractitioner.jsx';
import DeletePatient from '../../../components/Protocols/Groups/DeletePatient.jsx';
import SelectProtocol from '../../../components/Protocols/Groups/SelectProtocol.js'; 

const GroupDetailContainer = ({ group, onBack, updateGroup, protocolId }) => {

    const [dataPractitioner, queryPractitioner, totalSizePractitioner, isPractitionerLoading, addPractitioners, removePractitioner, handleTableChangePractitioner, handleFilterChangePractitioner, removeAllPractitioners] = useGroupPractitioners(group?.id);
    const [dataPatient, queryPatient, totalSizePatient, isPatientLoading, addPatients, removePatient, handleTableChangePatient, addPatientToPractitioner, handleFilterChange, removeAllPatients] = useGroupPatients(group?.id, protocolId);
    const [dataPatientPractitioner, queryPatientPractitioner, totalSizePatientPractitioner, isPatientPractitionerLoading, handleTableChangePatientPractitioner, updatePatientsPractitioner, handleQueryReset, reasignPatients, handleFilterChangePatientPractitioner] = useGroupPatientsPractitioner(group?.id, protocolId);
    const [, , editGroup] = useGroups();

    const { t } = useTranslation();
    const [modal, setModal] = useState(null);

    const [modalPatientsLoading, setModalPatientsLoading] = useState(true);
    const [currentPractitionerAssignments, setCurrentPractitionerAssignments] = useState([null]);

    const [auxList, setAuxList] = useState([]);

    const [currentPractitionerIdForAssignment, setCurrentPractitionerIdForAssignment] = useState(null);

    const [selectedPatient, setSelectedPatient] = useState([]);
    const [selectedPractitioner, setSelectedPractitioner] = useState([]);

    const [allPractitionersAssignments, setAllPractitionersAssignments] = useState([]);
    const [allPatientsUserAssignments, setAllPatientsUserAssignments] = useState([]);

    //#region Assigment

    useEffect(() => {

        if (currentPractitionerIdForAssignment) {

            setModalPatientsLoading(true);

            const initialAssignmentsForCurrentPractitioner = (group.groupsPatientsPractitioners || [])
                .filter(assignment => assignment.practitionerId === currentPractitionerIdForAssignment)
                .map(assignment => ({
                    groupId: assignment.groupId,
                    patientId: assignment.patientId,
                    practitionerId: assignment.practitionerId,
                }));

            setCurrentPractitionerAssignments(initialAssignmentsForCurrentPractitioner)
            //copio la lista antes de que seleccione "Todos" porque sino despues cuando desselecciona todos, pierde las asignaciones
            //que ya tenia
            setAuxList(initialAssignmentsForCurrentPractitioner) // sin esta lista perdia los pacientes que ye estaban asignados en un principio

            setModalPatientsLoading(false)
        }

    }, [currentPractitionerIdForAssignment]);


    useEffect(() => {
        // Para ver cuantos pacientes tiene asignado cada usuario
        if (!group.groupsPatientsPractitioners) {
            setAllPractitionersAssignments([]);
            setAllPatientsUserAssignments([]);
            return;
        }

        // L�gica para contar pacientes por usuario
        const practitionersMap = group.groupsPatientsPractitioners.reduce((acc, assignment) => {
            const { practitionerId } = assignment;
            if (acc[practitionerId]) {
                acc[practitionerId].count += 1;
            } else {
                acc[practitionerId] = {
                    practitionerId: practitionerId,
                    count: 1
                };
            }
            return acc;
        }, {});

        // L�gica para contar usuarios por paciente
        const patientsMap = group.groupsPatientsPractitioners.reduce((acc, assignment) => {
            const { patientId } = assignment;

            if (acc[patientId]) {
                acc[patientId].count += 1;
            } else {
                acc[patientId] = {
                    patientId: patientId,
                    count: 1
                };
            }
            return acc;
        }, {});


        const practitionersList = Object.values(practitionersMap);
        const patientsList = Object.values(patientsMap);

        setAllPractitionersAssignments(practitionersList);
        setAllPatientsUserAssignments(patientsList);

    }, [group]);

    const handleAssignPatientsClick = (practitionerId) => {
        setCurrentPractitionerIdForAssignment(practitionerId);
    };

    const toggleAssignPatientsModal = () => {
        setCurrentPractitionerIdForAssignment(null);
        setAuxList([])
    };

    const handlePatientCheckboxChange = (patientMedicalRecordNumber, isChecked) => {

        setCurrentPractitionerAssignments(prevAssignments => {
            if (isChecked) {
                const alreadyExists = prevAssignments.some(
                    (assignment) =>
                        assignment.patientId === patientMedicalRecordNumber &&
                        assignment.practitionerId === currentPractitionerIdForAssignment
                );

                if (!alreadyExists) {
                    // Si NO existe, a�ade la nueva relaci�n.
                    return [
                        ...prevAssignments,
                        {
                            groupId: group.id,
                            patientId: String(patientMedicalRecordNumber),
                            practitionerId: currentPractitionerIdForAssignment,
                        },
                    ];
                } else {
                    return prevAssignments;
                }
            } else {
                return prevAssignments.filter(
                    (assignment) =>
                        !(
                            assignment.patientId === patientMedicalRecordNumber &&
                            assignment.practitionerId === currentPractitionerIdForAssignment // Filtra solo la relaci�n con este profesional
                        )
                );
            }
        });
    };


    const handleSelectAllPatients = (isChecked) => {
        setCurrentPractitionerAssignments(prevAssignments => {
            if (isChecked) {
                const assignedPatientIds = prevAssignments
                    .filter(assignment => assignment.practitionerId === currentPractitionerIdForAssignment)
                    .map(assignment => assignment.patientId);

                let newAssignments = [...prevAssignments];

                dataPatientPractitioner.forEach(patient => {
                    const patientId = patient.medicalRecordNumber;

                    if (!assignedPatientIds.includes(String(patientId))) {
                        const newAssignment = {
                            groupId: group.id,
                            patientId: String(patientId),
                            practitionerId: currentPractitionerIdForAssignment,
                        };

                        newAssignments.push(newAssignment);
                    }
                });

                return newAssignments;
            }
            else {
                setCurrentPractitionerAssignments(auxList)
                return auxList
            }
        });
    }

    const handleConfirmAssignPatients = async () => {
        setModalPatientsLoading(true);

        updatePatientsPractitioner(currentPractitionerIdForAssignment, currentPractitionerAssignments)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.patientsSuccessfullyUpdated'))
            })
            .catch(err => {
                console.error("Error actualizando pacientes:", err);
                console.log(err.response.data)

                if (err?.response?.data?.Message) {
                    HandleError(err.response.data.Message);
                } else {
                    HandleError("Error al actualizar pacientes");
                }
            });

        toggleAssignPatientsModal();
        setModalPatientsLoading(false);
    };

    const handleClosee = () => {
        setModalPatientsLoading(true)
        handleQueryReset()
        toggleAssignPatientsModal()
    }

    const patientsPractitionerProp = {
        dataPatientPractitioner,
        queryPatientPractitioner,
        totalSizePatientPractitioner,
        handleTableChangePatientPractitioner,
        modalPatientsLoading,
        currentPractitionerAssignments,
        handlePatientCheckboxChange,
        handleClosee,
        handleConfirmAssignPatients,
        currentPractitionerIdForAssignment,
        handleFilterChangePatientPractitioner,
        handleSelectAllPatients,
    };
    //#endregion

    //#region Patients
    function addPatients_Handler(_fieldName, selectedValue) {

        if (!selectedValue) {
            setSelectedPatient([]);
            return;
        }

        const items = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
        if (items.length === 0) {
            setSelectedPatient([]);
            return;
        }

        const result = [];
        let skippedInGroup = false;
        let skippedDuplicate = false;

        for (const p of items) {
            if (!p?.medicalRecordNumber) continue;

            const inGroup = (group.groupsPatients ?? []).some(
                (gp) => String(gp.patientId) === String(p.medicalRecordNumber)
            );
            if (inGroup) {
                skippedInGroup = true;
                continue;
            }

            if (result.some((x) => String(x.medicalRecordNumber) === String(p.medicalRecordNumber))) {
                skippedDuplicate = true;
                continue;
            }
            result.push(p);
        }

        if (skippedInGroup) {
            HandleError(t('protocols.groups.patientExistGroup'));
        } else if (skippedDuplicate) {
            HandleError(t('protocols.groups.patientSelected'));
        }

        setSelectedPatient(result);
    }
    function confirmPatient() {

        if (!selectedPatient) {
            return;
        }

        const medicalRecordNumbers = selectedPatient.map(p => p.medicalRecordNumber);

        addPatients(medicalRecordNumbers)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.patientAddedGroup'))
            })
            .catch(err => {
                console.error("Error agregando practitioner:", err);
            });
    }

    function deletePatient_Handler(patientId) {
        if (!patientId) return;

        const alreadyExists = (group.groupsPatients ?? []).some(
            (p) => p.patientId === patientId
        );

        if (!alreadyExists) {
            return;
        }
        
        setModal(
            <ModalConfirm
                onCancel={() => setModal(null)}
                onConfirm={async () => {
                    try {
                        setModal(null);
                        await removePatient(patientId);
                        updateGroup();
                        Success(t('protocols.groups.patientDeletedGroup'))
                    } catch (err) {
                        console.error("Error borrando paciente:", err);
                    }
                }}
                title={t('protocols.groups.patientDeleteGroupConfirmation')}
                description={t('protocols.groups.patientDeleteGroupConfirmationDesc')}
            />
        );
    }

    function deleteAllPatients_Handler() {
        setModal(
            <ModalConfirm
                onCancel={() => setModal(null)}
                onConfirm={async () => {
                    try {
                        setModal(null);
                        await removeAllPatients();
                        updateGroup();
                        Success(t('protocols.groups.patientDeletedGroup'))
                    } catch (err) {
                        console.error("Error borrando pacientes:", err);
                    }
                }}
                title={t('protocols.groups.patientsDeleteAllConfirmation')}
                description={t('protocols.groups.patientsDeleteAllDescription')}
            />
        );
    }

    const patientsProp = {
        dataPatient,
        queryPatient,
        totalSizePatient,
        isPatientLoading,   
        handleTableChangePatient,
        addPatients_Handler, 
        handleFilterChange,
        selectedPatient,
        confirmPatient,
        allPatientsUserAssignments,
    };
    //#endregion

    //#region Practitioners
    function addPractitioners_Handler(_fieldName, selectedValue) {

        if (!selectedValue) {
            setSelectedPractitioner([])
            return
        }

        const lastSelected = Array.isArray(selectedValue) ? selectedValue[selectedValue.length - 1] : selectedValue;
        if (!lastSelected?.userId) return;

        const alreadyExists = (group.groupsPractitioners ?? []).some(
            (p) => p.practitionerId === lastSelected.userId
        );

        if (alreadyExists) {
            HandleError(t('protocols.groups.practitionerExistGroup'))
            setSelectedPractitioner(prev => [...prev])
            return;
        }

        const alreadyExistsInPicker = (selectedPractitioner ?? []).some(
            (p) => p.userId === lastSelected.userId
        );

        if (alreadyExistsInPicker) {
            HandleError(t('protocols.groups.practitionerSelected'))
            setSelectedPractitioner(prev => [...prev])
            return;
        }

        setSelectedPractitioner((prevHistory) => {
            return [...prevHistory, lastSelected];
        });
    }

    function confirmPractitioner() {

        if (!selectedPractitioner || selectedPractitioner.length === 0) {
            return;
        }

        const userIds = selectedPractitioner.map(p => p.userId);

        addPractitioners(userIds)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.practitionerAddedGroup'))
            })
            .catch(err => {
                console.error("Error agregando practitioner:", err);
            });
    }
    
    const deletePractitioner_Handler = (practitionerId) => {   
        
        if (!practitionerId) return;

        const alreadyExists = (group.groupsPractitioners ?? []).some(
            (p) => p.practitionerId === practitionerId
        );

        if (!alreadyExists) {
            return;
        }
        
        setModal(
            <ModalConfirm
                onCancel={() => setModal(null)}
                onConfirm={async () => {
                    
                    setModal(null); 
                    // verificar si tiene pacientes asignados
                    const patientsAssignedToThisPractitioner = group.groupsPatientsPractitioners.filter(
                        (assignment) => assignment.practitionerId === practitionerId 
                    );

                    if (patientsAssignedToThisPractitioner.length > 0) {
                        // Si tiene pacientes asignados, preguntar sobre la reasignaci�n
                        showReassignPatientsModal(practitionerId, patientsAssignedToThisPractitioner.map(p => p.patientId));
                    } else {
                        // Si no tiene pacientes, proceder directamente a la eliminaci�n
                        removePractitioner(practitionerId) // la API anterior que directamente elimina el profesional de la tabla 
                            .then(() => {
                                updateGroup();
                                Success(t('protocols.groups.practitionerDeletedGroup'));
                            })
                            .catch(err => {
                                HandleError(err.response?.data || "Error al eliminar el profesional.");
                            });
                    }
                }}
                title={t('protocols.groups.practitionerDeleteGroupConfirmation')}
            />
        );
    }

    const showReassignPatientsModal = (oldPractitionerId, assignedPatientIds) => {
        // Filtrar la lista de profesionales para excluir al que se est� eliminando
        const otherPractitionersInGroup = group.groupsPractitioners.filter(
            (p) => p.practitionerId !== oldPractitionerId
        );

        setModal(
            <ModalReassignPatients
                onCancel={() => setModal(null)}
                onConfirmReassign={(newPractitionerId) => {
                    setModal(null);
                    reasignPatients(oldPractitionerId, newPractitionerId, assignedPatientIds)
                        .then(() => {
                            updateGroup();
                            Success("reasignacion exitosa")
                        })
                        .catch(err => {
                            console.error("Error al reasignar pacientes:", err);
                            console.log(err.response.data)

                            if (err?.response?.data?.Message) {
                                HandleError(err.response.data.Message);
                            } else {
                                HandleError("Error al reasignar pacientes.");
                            }
                        });
                }}
                practitioners={otherPractitionersInGroup} 
                assignedPatientCount={assignedPatientIds.length} 
                title={t('protocols.groups.reasignPatients')}
                description = { t('protocols.groups.reasignPatientsDesc') }
            />
        );
    };

    const deleteAllPractitioners_Handler = () => {
        setModal(
            <ModalConfirm
                onCancel={() => setModal(null)}
                onConfirm={async () => {
                    try {
                        setModal(null);
                        await removeAllPractitioners();
                        updateGroup();
                        Success(t('protocols.groups.practitionerDeletedGroup'))
                    } catch (err) {
                        console.error("Error borrando usuarios:", err);
                    }
                }}
                title={t('protocols.groups.practitionersDeleteAllConfirmation')}
                description={t('protocols.groups.practitionersAllDescription')}
            />
        );
    }

    
    const practitionersProp = {
        dataPractitioner,
        queryPractitioner,
        totalSizePractitioner,
        isPractitionerLoading,
        handleTableChangePractitioner,
        addPractitioners_Handler,
        deletePractitioner_Handler,
        handleAssignPatientsClick,
        modalPatientsLoading,
        selectedPatient,
        confirmPractitioner,
        handleFilterChangePractitioner,
        deleteAllPractitioners_Handler,
        allPractitionersAssignments,
    };
    //#endregion

    const handleEditGroup = async (groupId, groupData) => {
        editGroup(groupId, groupData)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.updatedGroup'))
            })
            .catch(err => {
                console.error("Error actualizando grupo:", err);
                console.log(err.response.data)

                if (err?.response?.data?.Message) {
                    HandleError(err.response.data.Message);
                } else {
                    HandleError("Error actualizando grupo.");
                }
            });
    }

    

    return (
        <>
            <GroupDetail 
                onBack={onBack}
                patientsProp={patientsProp}
                practitionersProp={practitionersProp}
                patientsPractitionerProp={patientsPractitionerProp}
                group={group}
                editGroupButton={<EditGroup group={group} editGroup={handleEditGroup} buttonStyle="inGroup" />}
                deleteAllPractitionersButton={< DeleteAllUsers deleteAllPractitioners={deleteAllPractitioners_Handler} />}
                deleteAllPatientsButton={< DeleteAllPatients deleteAllPatients={deleteAllPatients_Handler} />}
                AddPractitionersButton={< AddPractitioners addPractitioners={addPractitioners_Handler} confirmPractitioners={confirmPractitioner} selectedPractitioners={selectedPractitioner} />}
                deletePractitionerButton={< DeletePractitioner deletePractitioner={deletePractitioner_Handler} />}
                deletePatientButton={< DeletePatient deletePatient={deletePatient_Handler} />}
                addPatientsButton={< AddPatients addPatients={addPatients_Handler} confirmPatients={confirmPatient} selectedPatients={selectedPatient } />}
                handleProtocolChange={handleFilterChange}
                selectProtocolComponent={< SelectProtocol group={group} handleFilterChange={handleFilterChange} />}
            />
            {modal}
        </>
        
    );
};

export default GroupDetailContainer;